// import React, { Suspense, useEffect, useState } from 'react';
// import { Routes, Route, useParams, useNavigate, useLocation, Navigate } from 'react-router-dom';
// import PrivateRoute from './PrivateRoute'; // Keep your private route logic intact
// import LoadingSpinner from '../components/common/LoadingSpinner';
// import BaseDetails from '../features/setting/baseSetting/BaseDetails';
// import SettingLayout from '../components/setting/SettingLayout';
// import { useAppSelector } from '../app/hooks';
// import DetailsLayout from '../features/setting/baseSetting/details/DetailsLayout';
// import BaseMember from '../features/setting/baseSetting/BaseMember';
// import UserLayout from '../components/user/UserLayout';
// import UserProfile from '../features/setting/profileSetting/UserProfile';
// import UserSecurity from '../features/setting/profileSetting/UserSecurity';
// import { isDotDotDotToken } from 'typescript';
// import MemberLayout from '../features/setting/baseSetting/members/MemberLayout';
// import BaseMemberPending from '../features/setting/baseSetting/members/BaseMemberPending';
// import Teams from '../features/setting/baseSetting/Teams';
// import TeamDetails from '../features/setting/baseSetting/teamMember/TeamMemberDataDetails';
// import TeamMemberLayout from '../features/setting/baseSetting/teamMember/TeamMemberLayout';
// import TeamMemberDetails from '../features/setting/baseSetting/teamMember/TeamMemberDetails';
// import TeamMemberDataDetails from '../features/setting/baseSetting/teamMember/TeamMemberDataDetails';
// import TeamMemberPending from '../features/setting/baseSetting/teamMember/TeamMemberPending';
// import BaseLocation from '../features/setting/baseSetting/BaseLocation';
// import DepartmentMemberLayout from '../features/setting/baseSetting/department/DepartmentMemberLayout';
// import DepartmentMemberDetails from '../features/setting/baseSetting/department/DepartmentMemberDetails';
// import Departments from '../features/setting/baseSetting/Departments';
// import CreateDepartment from '../features/setting/baseSetting/CreateDepartment';
// import Pipeline from '../features/setting/baseSetting/Pipeline';
// import ViewDepartment from '../features/setting/baseSetting/ViewDepartment';
// import PipelineStages from '../features/setting/baseSetting/PipelineStages';
// import Tags from '../features/setting/baseSetting/Tags';
// import ScoreCard from '../features/setting/baseSetting/ScoreCard';
// import Skills from '../features/setting/baseSetting/Skills';
// import Questionnaire from '../features/setting/baseSetting/Questionnaire';
// import QuestionList from '../features/setting/baseSetting/QuestionList';
// import Email from '../features/setting/baseSetting/email/Email';
// import CreateEmail from '../features/setting/baseSetting/email/CreateEmail';
// import JobLayout from '../components/job/JobLayout';
// import JobHome from '../components/job/JobHome';
// import { EditorProvider } from '../context/EditorContext';
// import AuthRoute from './AuthRoute';
// import JobsListing from '../pages/JobsListing';
// import JobList from '../pages/JobsListing/JobList';
// import { SearchProvider } from '../context/SearchContext';
// import JobPipelineDetails from '../components/job/JobPipelineDetails';
// import PipelineContainer from '../components/job/PipelineContainer';
// import HiringPipelineContainer from '../components/hiringteam/HiringPipelineContainer';
// import ScoreCardContainer from '../components/scorecard/ScoreCardContainer';
// import ScoreCardSkill from '../components/scorecard/ScoreCardSkill';
// import JobQuestionnaireContainer from '../components/jobquestionnaire/JobQuestionnaireContainer';
// import JobQuestionSetDetails from '../components/jobquestionnaire/JobQuestionSetDetails';
// import JobApplication from '../components/application/JobApplication';
// import { JobApplicationProvider } from '../components/application/JobApplicationContext';
// import JobDetailsList from '../pages/JobDetailsListing/JobDetailsList';
// import JobDetailsListing from '../pages/JobDetailsListing';
// import { SidebarProvider } from '../context/SidebarContext';
// import { CustomVerticalMenuContext } from '../context/CustomVerticalMenuContext';
// import { CustomHoverContext } from '../context/CustomHoverContext';
// import BaseManage from '../features/setting/baseSetting/BaseManage';
// import CandidateLayout from '../components/jobApplicationDetails/CandidateLayout';
// import Reports from '../pages/JobDetailsListing/dashboardReport/Reports';
// import ApplicationJobHeaderReports from '../pages/JobDetailsListing/dashboardReport/ApplicationJobHeaderReports';
// import JobSkillScorecard from '../components/jobApplicationDetails/JobSkillScorecard';
// import Review from '../features/setting/baseSetting/reviewTemplate/Review';
// import CreateReview from '../features/setting/baseSetting/reviewTemplate/CreateReview';
// import ReviewTemplateContainer from '../components/jobReviewTemplate/ReviewTemplateContainer';
// import CreateReviewTemplateDetails from '../components/jobReviewTemplate/CreateReviewTemplateDetails';
// import EditReviewTemplateDetails from '../components/jobReviewTemplate/EditReviewTemplateDetails';
// import Inbox from '../components/dashboard/Inbox';
// import Application from '../components/dashboard/application/Application';
// import ApplicationLayout from '../pages/ApplicationLayout';
// import TaskListing from '../components/dashboard/Task/TaskListing';
// import { CalenderIcon } from '../components/icons';
// import Calender from '../components/dashboard/Calender/Calender';
// import BaseJobList from '../components/base/BaseJobList';


// // Lazy load components
// const LoginForm = React.lazy(() => import('../components/auth/LoginForm'));
// const RegisterForm = React.lazy(() => import('../components/auth/RegisterForm'));
// const ForgotForm = React.lazy(() => import('../components/auth/ForgotForm'));
// const ResetForm = React.lazy(() => import('../components/auth/ResetForm'));
// const OtpForm = React.lazy(() => import('../components/auth/OtpForm'));
// const DashboardLayout = React.lazy(() => import('../components/dashboard/DashboardLayout'));
// const DashboardHome = React.lazy(() => import('../components/dashboard/DashboardHome'));
// const BaseList = React.lazy(() => import('../components/base/BaseList'));
// const NotFound = React.lazy(() => import('../components/errors/NotFound'));
// const UserPage = React.lazy(() => import('../components/user'));
// const CreateBase = React.lazy(() => import('../components/base/CreateBase'));

// // Import all your components here (keeping the existing imports)

// // New AdminRoute component
// const AdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
//   const navigate = useNavigate();
//   const [userData, setUserData] = useState<any>(null);
//   const [userBaseData, setUserBaseData] = useState<any>(null)
//   const [isAdmin, setIsAdmin] = useState<boolean | null>(null);

//   useEffect(() => {
//     const userBaseDetailsString = localStorage.getItem('baseDetails');
//     if (userBaseDetailsString) {
//       try {
//         const userBaseDetails = JSON.parse(userBaseDetailsString);
//         setUserBaseData(userBaseDetails?.data);
//       } catch (e) {
//         console.error("Error parsing userDetails:", e);
//       }
//     }
//   }, []);

//   // user details
//   // useEffect(() => {
//   //   const userDetailsString = localStorage.getItem('userDetails');
//   //   if (userDetailsString) {
//   //     try {
//   //       const userDetailsData = JSON.parse(userDetailsString);
//   //       setUserData(userDetailsData);
//   //     } catch (e) {
//   //       console.error("Error parsing userDetails:", e);
//   //     }
//   //   }
//   // }, []);

//   useEffect(() => {
//     const userDetailsString = localStorage.getItem('userDetails');
//     if (userDetailsString) {
//       try {
//         const userDetailsData = JSON.parse(userDetailsString);
//         setIsAdmin(userDetailsData.role === 'admin');
//         setUserData(userDetailsData);
//       } catch (e) {
//         console.error("Error parsing userDetails:", e);
//         setIsAdmin(false);
//       }
//     } else {
//       setIsAdmin(false);
//     }
//   }, []);

//   // useEffect(() => {
//   //   if (userData?.role !== 'admin') {
//   //     navigate(`/${userData?.current_base}/dashboard`);
//   //   }
//   // }, [userData, navigate]);

//   // if (userData?.role !== 'admin') {
//   //   return <Navigate to={`/${userData?.current_base}/dashboard`} />;
//   // }

//   // return <>{children}</>;
//   if (isAdmin === null) {
//     return <LoadingSpinner />;
//   }


//   return isAdmin ? <>{children}</> : <Navigate to={`/${userData?.current_base}/dashboard`} replace />;
// };

// const AppRoutes: React.FC = () => {
//   const [userDetails, setUserDetails] = useState<any>(null);
//   const userDetailsFromRedux = useAppSelector((state: any) => state.auth.userDetails);
//   const { base, user, isAuthenticated } = useAppSelector((state: any) => state.auth);
//   const { baseId } = useParams<{ baseId: string }>();
//   const [userData, setUserData] = useState<any>(null);
//   const [userBaseData, setUserBaseData] = useState('');
//   const navigate = useNavigate();
//   const location = useLocation();

//   // Your existing useEffects here

//   useEffect(() => {
//     const storedUserDetails = JSON.parse(localStorage.getItem("UserBaseId") || "{}");
//     setUserDetails(storedUserDetails);
//   }, []);

//   const UserDetailsData = user || userDetails;

//   return (
//     <Suspense fallback={<LoadingSpinner />}>
//       <SearchProvider>
//         <EditorProvider>
//           <SidebarProvider>
//             <CustomVerticalMenuContext>
//               <CustomHoverContext>
//                 <Routes>
//                   <Route path="/" element={
//                     <AuthRoute><LoginForm /></AuthRoute>
//                   } />
//                   <Route path="/signup" element={
//                     <AuthRoute><RegisterForm /></AuthRoute>
//                   } />
//                   <Route path="/forgotpassword" element={
//                     <AuthRoute><ForgotForm /></AuthRoute>
//                   } />
//                   <Route path="/reset-password" element={
//                     <AuthRoute><ResetForm /></AuthRoute>
//                   } />
//                   <Route path="/reset-password/:token" element={
//                     <AuthRoute><ResetForm /></AuthRoute>
//                   } />
//                   <Route path="/otp" element={
//                     <AuthRoute><OtpForm /></AuthRoute>
//                   } />

//                   {/* Private routes (protected) */}
//                   <Route
//                     path="/base"
//                     element={
//                       <PrivateRoute>
//                         <BaseList userDetails1={UserDetailsData} />
//                       </PrivateRoute>
//                     }
//                   />
//                   <Route
//                     path="/:baseId/dashboard/jobs"
//                     element={
//                       <PrivateRoute>
//                         <BaseJobList userDetails1={UserDetailsData} />
//                       </PrivateRoute>
//                     }
//                   />

//                   <Route path="/:baseId/settings/*" element={
//                     <PrivateRoute>
//                       <SettingLayout userDetails={UserDetailsData}>
//                         <Routes>
//                           <Route path="/base/*" element={
//                             <AdminRoute>
//                               <DetailsLayout userDetails={UserDetailsData}>
//                                 <Routes>
//                                   <Route index element={<BaseDetails userDetails={UserDetailsData} />} />
//                                   <Route path="manage" element={<BaseManage />} />
//                                   <Route path="board" element={<UserPage />} />
//                                   <Route path="tags" element={<UserPage />} />
//                                 </Routes>
//                               </DetailsLayout>
//                             </AdminRoute>
//                           } />

//                           <Route path="/member/*" element={
//                             <AdminRoute>
//                               <MemberLayout userDetails={UserDetailsData}>
//                                 <Routes>
//                                   <Route index element={<BaseMember userDetails={UserDetailsData} />} />
//                                   <Route path="pending" element={<BaseMemberPending userDetails={UserDetailsData} />} />
//                                 </Routes>
//                               </MemberLayout>
//                             </AdminRoute>
//                           } />

//                           <Route path="teams/*" element={
//                             <AdminRoute>
//                               <Teams userDetails={UserDetailsData} />
//                             </AdminRoute>
//                           } />

//                           <Route path="teams/:userId/detail/*" element={
//                             <AdminRoute>
//                               <TeamMemberLayout userDetails={UserDetailsData}>
//                                 <Routes>
//                                   <Route index element={<TeamMemberDetails userDetails={UserDetailsData} />} />
//                                   <Route path="member" element={<TeamMemberDataDetails userDetails={UserDetailsData} />} />
//                                   <Route path="pending" element={<TeamMemberPending userDetails={UserDetailsData} />} />
//                                 </Routes>
//                               </TeamMemberLayout>
//                             </AdminRoute>
//                           } />

//                           <Route path="tags" element={
//                             <AdminRoute>
//                               <Tags />
//                             </AdminRoute>
//                           }
//                           />
//                           <Route path="location" element={
//                             <AdminRoute>
//                               <BaseLocation userDetails={UserDetailsData} />
//                             </AdminRoute>
//                           }
//                           />
//                           <Route path="department/*" element={
//                             <AdminRoute>
//                               <Departments userDetails={UserDetailsData} />
//                             </AdminRoute>
//                           } />
//                           <Route path="department/:userId/detail/*" element={
//                             <AdminRoute>
//                               <DepartmentMemberLayout userDetails={UserDetailsData}>
//                                 <Routes>
//                                   <Route index element={<DepartmentMemberDetails userDetails={UserDetailsData} />} />
//                                   <Route path="list" element={<TeamMemberDataDetails userDetails={UserDetailsData} />} />
//                                 </Routes>
//                               </DepartmentMemberLayout>
//                             </AdminRoute>
//                           } />
//                           <Route path="department/:departmentId/edit" element={
//                             <AdminRoute>
//                               <CreateDepartment userDetails={UserDetailsData} />
//                             </AdminRoute>
//                           } />
//                           <Route path="department/:departmentId/view" element={
//                             <AdminRoute>
//                               <ViewDepartment userDetails={UserDetailsData} />
//                             </AdminRoute>
//                           } />
//                           <Route path="pipeline" element={
//                             <AdminRoute>
//                               <Pipeline userDetails={UserDetailsData} />
//                             </AdminRoute>
//                           }
//                           />
//                           <Route path="pipeline/:userId" element={
//                             <AdminRoute>
//                               <PipelineStages userDetails={UserDetailsData} />
//                             </AdminRoute>
//                           } />
//                           <Route path="scorecard" element={
//                             <AdminRoute>
//                               <ScoreCard userDetails={UserDetailsData} />
//                             </AdminRoute>
//                           }
//                           />
//                           <Route path="scorecard/:userId" element={
//                             <AdminRoute>
//                               <Skills userDetails={UserDetailsData} />
//                             </AdminRoute>
//                           } />
//                           <Route path="questionnaire" element={
//                             <AdminRoute>
//                               <Questionnaire userDetails={UserDetailsData} />
//                             </AdminRoute>
//                           }
//                           />
//                           <Route path="questionnaire/:userId" element={
//                             <AdminRoute>
//                               <QuestionList userDetails={UserDetailsData} />
//                             </AdminRoute>
//                           } />
//                           <Route path="email" element={
//                             <AdminRoute>
//                               <Email userDetails={UserDetailsData} />
//                             </AdminRoute>
//                           }
//                           />
//                           <Route path="email/create" element={
//                             <AdminRoute>
//                               <CreateEmail userDetails={UserDetailsData} />
//                             </AdminRoute>
//                           }
//                           />
//                           <Route path="email/edit/:userId" element={
//                             <AdminRoute>
//                               <CreateEmail userDetails={UserDetailsData} />
//                             </AdminRoute>
//                           }
//                           />
//                           <Route path="email/:userId" element={
//                             <AdminRoute>
//                               <QuestionList userDetails={UserDetailsData} />
//                             </AdminRoute>
//                           } />

//                           <Route path="reviewtemplate" element={
//                             <AdminRoute>
//                               <Review userDetails={UserDetailsData} />
//                             </AdminRoute>
//                           }
//                           />
//                           <Route path="reviewtemplate/create" element={
//                             <AdminRoute>
//                               <CreateReview userDetails={UserDetailsData} />
//                             </AdminRoute>
//                           }
//                           />
//                           <Route path="reviewtemplate/edit/:userId" element={
//                             <AdminRoute>
//                               <CreateReview userDetails={UserDetailsData} />
//                             </AdminRoute>
//                           }
//                           />
//                           {/* <Route path="reviewtemplate/:userId" element={
//                             <AdminRoute>
//                               <QuestionList userDetails={UserDetailsData} />
//                             </AdminRoute>
//                           } /> */}

//                         </Routes>
//                       </SettingLayout>
//                     </PrivateRoute>
//                   } />

//                   {/* Other routes remain unchanged */}
//                   <Route
//                     path="/createbase"
//                     element={
//                       <PrivateRoute>
//                         <CreateBase userDetails={UserDetailsData} />
//                       </PrivateRoute>
//                     }
//                   />

//                   <Route
//                     path="/:baseId/*"
//                     element={
//                       <PrivateRoute>
//                         <DashboardLayout userDetails={UserDetailsData}>
//                           <Suspense fallback={<LoadingSpinner />}>
//                             <Routes>
//                               <Route path="dashboard" element={<DashboardHome />} />
//                               <Route path="user1" element={<UserPage />} />
//                               <Route path="document" element={<DashboardHome />} />
//                               <Route path="jobs/*" element={<JobsListing />} />
//                               <Route path="task/*" element={<TaskListing />} />
//                               <Route path='calender' element={<Calender />} />
//                               <Route path="inbox" element={<Inbox />} />
//                               <Route path="inbox/job/:jobId/app/:applicationId" element={<Inbox />} />
//                               <Route path="application" element={<Application />} />
//                               <Route path="application/job/:jobId/app" element={<Application />} />
//                             </Routes>
//                           </Suspense>
//                         </DashboardLayout>
//                       </PrivateRoute>
//                     }
//                   />

//                   <Route path="/user/:baseId/*" element={
//                     <PrivateRoute>
//                       <UserLayout userDetails={UserDetailsData}>
//                         <Routes>
//                           <Route path="profile" element={<UserProfile />} />
//                           <Route path="security" element={<UserSecurity />} />
//                         </Routes>
//                       </UserLayout>
//                     </PrivateRoute>
//                   } />


//                   {/* job setting listing*/}

//                   <Route
//                     path="/:baseId/job/:jobId/manage/*"
//                     element={
//                       <JobApplicationProvider>
//                         <PrivateRoute>
//                           <JobLayout userDetails={UserDetailsData}>
//                             <Suspense fallback={<LoadingSpinner />}>
//                               <Routes>
//                                 <Route path="detail/*" element={<JobHome />} />
//                                 <Route path="pipeline/*" element={<PipelineContainer />} />
//                                 <Route path="hiring_team/*" element={<HiringPipelineContainer />} />
//                                 <Route path="scorecard/*" element={<ScoreCardContainer />} />
//                                 <Route path="scorecard/:userId" element={<ScoreCardSkill userDetails={UserDetailsData} />} />
//                                 <Route path="questionnaire/*" element={<JobQuestionnaireContainer />} />
//                                 <Route path="questionnaire/:userId" element={<JobQuestionSetDetails />} />
//                                 <Route path="reviewtemplate/*" element={<ReviewTemplateContainer />} />
//                                 <Route path="reviewtemplate/:userId" element={<EditReviewTemplateDetails />} />
//                                 <Route path="reviewtemplate/create*" element={<CreateReviewTemplateDetails />} />
//                                 {/* <Route path="reviewtemplate" element={<CreateReviewTemplateDetails />} /> */}
//                                 <Route path="application/*" element={<JobApplication />} />
//                               </Routes>
//                             </Suspense>
//                           </JobLayout>
//                         </PrivateRoute>
//                       </JobApplicationProvider>
//                     }
//                   />


//                   {/* jpb details listing */}

//                   <Route
//                     path="/:baseId/job/:jobId/*"
//                     element={
//                       <PrivateRoute>
//                         <ApplicationLayout userDetails={UserDetailsData}>
//                           <Suspense fallback={<LoadingSpinner />}>
//                             <Routes>
//                               <Route path="application" element={<JobDetailsListing />} />
//                               <Route path="pipeline" element={<JobDetailsListing />} />
//                               <Route path="reports" element={<ApplicationJobHeaderReports />} />
//                             </Routes>
//                           </Suspense>
//                         </ApplicationLayout>
//                       </PrivateRoute>
//                     }
//                   />


//                   {/* job application details */}

//                   <Route
//                     path="/:baseId/job/:jobId/app/:applicationId*"
//                     element={
//                       <PrivateRoute>
//                         <CandidateLayout userDetails={UserDetailsData}>
//                           <Suspense fallback={<LoadingSpinner />}>
//                             <Routes>
//                               <Route path="overview/*" element={<JobHome />} />
//                               <Route path="resume/*" element={<PipelineContainer />} />
//                               <Route path="scorecards/:skillId*" element={<JobSkillScorecard />} />
//                               <Route path="scorecards/:skillId/edit*" element={<JobSkillScorecard />} />
//                             </Routes>
//                           </Suspense>
//                         </CandidateLayout>
//                       </PrivateRoute>
//                     }
//                   />



//                   {/* <Route
//               path="/:baseId/job/:jobId/*"
//               element={
//                 <JobApplicationProvider>
//                   <PrivateRoute>
//                     <JobLayout userDetails={UserDetailsData}>
//                       <Suspense fallback={<LoadingSpinner />}>
//                         <Routes>
//                           <Route path="detail/*" element={<JobHome />} />
//                           <Route path="pipeline/*" element={<PipelineContainer />} />
//                           <Route path="hiring_team/*" element={<HiringPipelineContainer />} />
//                           <Route path="scorecard/*" element={<ScoreCardContainer />} />
//                           <Route path="scorecard/:userId" element={<ScoreCardSkill userDetails={UserDetailsData} />} />
//                           <Route path="questionnaire/*" element={<JobQuestionnaireContainer />} />
//                           <Route path="questionnaire/:userId" element={<JobQuestionSetDetails />} />
//                           <Route path="application/*" element={<JobApplication />} />
//                         </Routes>
//                       </Suspense>
//                     </JobLayout>
//                   </PrivateRoute>
//                 </JobApplicationProvider>
//               }
//             /> */}


//                   <Route path="*" element={<NotFound />} />
//                 </Routes>
//               </CustomHoverContext>

//             </CustomVerticalMenuContext>

//           </SidebarProvider>

//         </EditorProvider>
//       </SearchProvider>
//     </Suspense>
//   );
// };

// export default AppRoutes;


//@ts-nocheck
import React, { Suspense, useEffect, useState } from 'react';
import { Routes, Route, useParams, useNavigate, useLocation, Navigate } from 'react-router-dom';
import PrivateRoute from './PrivateRoute'; // Keep your private route logic intact
import LoadingSpinner from '../components/common/LoadingSpinner';
import BaseDetails from '../features/setting/baseSetting/BaseDetails';
import SettingLayout from '../components/setting/SettingLayout';
import { useAppSelector } from '../app/hooks';
import DetailsLayout from '../features/setting/baseSetting/details/DetailsLayout';
import BaseMember from '../features/setting/baseSetting/BaseMember';
import UserLayout from '../components/user/UserLayout';
import UserProfile from '../features/setting/profileSetting/UserProfile';
import UserSecurity from '../features/setting/profileSetting/UserSecurity';
import MemberLayout from '../features/setting/baseSetting/members/MemberLayout';
import BaseMemberPending from '../features/setting/baseSetting/members/BaseMemberPending';
import Teams from '../features/setting/baseSetting/Teams';
import TeamMemberLayout from '../features/setting/baseSetting/teamMember/TeamMemberLayout';
import TeamMemberDetails from '../features/setting/baseSetting/teamMember/TeamMemberDetails';
import TeamMemberDataDetails from '../features/setting/baseSetting/teamMember/TeamMemberDataDetails';
import TeamMemberPending from '../features/setting/baseSetting/teamMember/TeamMemberPending';
import BaseLocation from '../features/setting/baseSetting/BaseLocation';
import DepartmentMemberLayout from '../features/setting/baseSetting/department/DepartmentMemberLayout';
import DepartmentMemberDetails from '../features/setting/baseSetting/department/DepartmentMemberDetails';
import Departments from '../features/setting/baseSetting/Departments';
import CreateDepartment from '../features/setting/baseSetting/CreateDepartment';
import Pipeline from '../features/setting/baseSetting/Pipeline';
import ViewDepartment from '../features/setting/baseSetting/ViewDepartment';
import PipelineStages from '../features/setting/baseSetting/PipelineStages';
import Tags from '../features/setting/baseSetting/Tags';
import ScoreCard from '../features/setting/baseSetting/ScoreCard';
import Skills from '../features/setting/baseSetting/Skills';
import Questionnaire from '../features/setting/baseSetting/Questionnaire';
import QuestionList from '../features/setting/baseSetting/QuestionList';
import Email from '../features/setting/baseSetting/email/Email';
import CreateEmail from '../features/setting/baseSetting/email/CreateEmail';
import JobLayout from '../components/job/JobLayout';
import JobHome from '../components/job/JobHome';
import CandidateAiInterview from '../components/job/JobAiInterview';
import { EditorProvider } from '../context/EditorContext';
import AuthRoute from './AuthRoute';
import { SearchProvider } from '../context/SearchContext';
import PipelineContainer from '../components/job/PipelineContainer';
import HiringPipelineContainer from '../components/hiringteam/HiringPipelineContainer';
import ScoreCardContainer from '../components/scorecard/ScoreCardContainer';
import ScoreCardSkill from '../components/scorecard/ScoreCardSkill';
import JobQuestionnaireContainer from '../components/jobquestionnaire/JobQuestionnaireContainer';
import JobQuestionSetDetails from '../components/jobquestionnaire/JobQuestionSetDetails';
import JobApplication from '../components/application/JobApplication';
import JobInternal from '../components/internal/JobApplication';
import { JobApplicationProvider } from '../components/application/JobApplicationContext';
import JobDetailsListing from '../pages/JobDetailsListing';
import { SidebarProvider } from '../context/SidebarContext';
import { CustomVerticalMenuContext } from '../context/CustomVerticalMenuContext';
import { CustomHoverContext } from '../context/CustomHoverContext';
import BaseManage from '../features/setting/baseSetting/BaseManage';
import CandidateLayout from '../components/jobApplicationDetails/CandidateLayout';
import ApplicationJobHeaderReports from '../pages/JobDetailsListing/dashboardReport/ApplicationJobHeaderReports';
import JobSkillScorecard from '../components/jobApplicationDetails/JobSkillScorecard';
import Review from '../features/setting/baseSetting/reviewTemplate/Review';
import CreateReview from '../features/setting/baseSetting/reviewTemplate/CreateReview';
import ReviewTemplateContainer from '../components/jobReviewTemplate/ReviewTemplateContainer';
import CreateReviewTemplateDetails from '../components/jobReviewTemplate/CreateReviewTemplateDetails';
import EditReviewTemplateDetails from '../components/jobReviewTemplate/EditReviewTemplateDetails';
import Inbox from '../components/dashboard/Inbox';
import Application from '../components/dashboard/application/Application';
import ApplicationLayout from '../pages/ApplicationLayout';
import TaskListing from '../components/dashboard/Task/TaskListing';
import Calender from '../components/dashboard/Calender/Calender';
import JobActionDetails from '../components/jobActions/JobActionDetails';
import { JobProvider } from '../components/dashboard/JobContext';
import CreateNewJob from '../components/CreateNewJob';
import JobHomeLayout from '../components/jobHomeLayout/JobHomeLayout';
import Bookmark from '../pages/JobDetailsListing/Bookmark';
import Rating from '../pages/JobDetailsListing/Rating';
import Evaluation from '../pages/JobDetailsListing/evaluation';
import BillingLayout from '../features/setting/baseSetting/billing/BillingLayout';
import BillingPlan from '../features/setting/baseSetting/billing/BillingPlan';
import BillingInvoice from '../features/setting/baseSetting/billing/BillingInvoice';
import Updates from '../components/dashboard/Updates';
import DistributionContainer from '../components/Distribution/DistributionContainer';
import Kanban from '../pages/JobDetailsListing/Kanban';
import EvaluationApplication from '../components/evaluation/EvalutionApplication';


// Lazy load components
const LoginForm = React.lazy(() => import('../components/auth/LoginForm'));
const RegisterForm = React.lazy(() => import('../components/auth/RegisterForm'));
const ForgotForm = React.lazy(() => import('../components/auth/ForgotForm'));
const ResetForm = React.lazy(() => import('../components/auth/ResetForm'));
const OtpForm = React.lazy(() => import('../components/auth/OtpForm'));
const DashboardLayout = React.lazy(() => import('../components/dashboard/DashboardLayout'));
const DashboardHome = React.lazy(() => import('../components/dashboard/DashboardHome'));
const BaseList = React.lazy(() => import('../components/base/BaseList'));
const NotFound = React.lazy(() => import('../components/errors/NotFound'));
const UserPage = React.lazy(() => import('../components/user'));
const CreateBase = React.lazy(() => import('../components/base/CreateBase'));

// New AdminRoute component
const AdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState<any>(null);
  const [userBaseData, setUserBaseData] = useState<any>(null)
  const [isAdmin, setIsAdmin] = useState<boolean | null>(null);

  useEffect(() => {
    const userBaseDetailsString = localStorage.getItem('baseDetails');
    if (userBaseDetailsString) {
      try {
        const userBaseDetails = JSON.parse(userBaseDetailsString);
        setUserBaseData(userBaseDetails?.data);
      } catch (e) {
        console.error("Error parsing userDetails:", e);
      }
    }
  }, []);

  // user details
  // useEffect(() => {
  //   const userDetailsString = localStorage.getItem('userDetails');
  //   if (userDetailsString) {
  //     try {
  //       const userDetailsData = JSON.parse(userDetailsString);
  //       setUserData(userDetailsData);
  //     } catch (e) {
  //       console.error("Error parsing userDetails:", e);
  //     }
  //   }
  // }, []);

  useEffect(() => {
    const userDetailsString = localStorage.getItem('userDetails');
    if (userDetailsString) {
      try {
        const userDetailsData = JSON.parse(userDetailsString);
        setUserData(userDetailsData);
      } catch (e) {
        console.error("Error parsing userDetails:", e);
      }
    }
  }, []);


  useEffect(() => {
    const userDetailsString = localStorage.getItem('baseSwitchDetails');
    if (userDetailsString) {
      try {
        const userDetails = JSON.parse(userDetailsString);
        setIsAdmin(userDetails.role === 'admin')
      } catch (e) {
        console.error("Error parsing userDetails:", e);
        setIsAdmin(false);
      }
    }
  }, []);


  // useEffect(() => {
  //   if (userData?.role !== 'admin') {
  //     navigate(`/${userData?.current_base}/dashboard`);
  //   }
  // }, [userData, navigate]);

  // if (userData?.role !== 'admin') {
  //   return <Navigate to={`/${userData?.current_base}/dashboard`} />;
  // } 

  // return <>{children}</>;
  if (isAdmin === null) {
    return <LoadingSpinner />;
  }

  return isAdmin ? <>{children}</> : <Navigate to={`/${userData?.current_base}/dashboard`} replace />;
};


// Create a new JobAdminRoute component specifically for job management routes
const JobAdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();
  const { baseId, jobId } = useParams<{ baseId: string, jobId: string }>();
  const [isAdmin, setIsAdmin] = useState<boolean | null>(null);
  const location = useLocation();

  useEffect(() => {
    const jobDetailsString = localStorage.getItem('jobPostDetailsData');
    if (jobDetailsString) {
      try {
        const jobDetails = JSON.parse(jobDetailsString);
        // Check if user is admin
        if (jobDetails?.role === 'admin') {
          setIsAdmin(true);
        } else {
          setIsAdmin(false);
          // Redirect non-admin users to application page
          navigate(`/${baseId}/job/${jobId}/dashboard`, { replace: true });
        }
      } catch (e) {
        console.error("Error parsing job details:", e);
        setIsAdmin(false);
        navigate(`/${baseId}/job/${jobId}/dashboard`, { replace: true });
      }
    } else {
      // If no job details found, assume not admin
      setIsAdmin(false);
      navigate(`/${baseId}/job/${jobId}/dashboard`, { replace: true });
    }
  }, [baseId, jobId, navigate]);

  if (isAdmin === null) {
    return <LoadingSpinner />;
  }

  return isAdmin ? <>{children}</> : null;
};


const AppRoutes: React.FC = () => {
  const [userDetails, setUserDetails] = useState<any>(null);
  const userDetailsFromRedux = useAppSelector((state: any) => state.auth.userDetails);
  const { base, user, isAuthenticated } = useAppSelector((state: any) => state.auth);
  const { baseId } = useParams<{ baseId: string }>();
  const [userData, setUserData] = useState<any>(null);
  const [userBaseData, setUserBaseData] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const [getJobData, setGetJobData] = useState<any>(null);
  // Your existing useEffects here

  useEffect(() => {
    const storedUserDetails = JSON.parse(localStorage.getItem("UserBaseId") || "{}");
    setUserDetails(storedUserDetails);
  }, []);

  const UserDetailsData = user || userDetails;

  return (
    <Suspense fallback={<LoadingSpinner />}>
      <SearchProvider>
        <EditorProvider>
          <SidebarProvider>
            <CustomVerticalMenuContext>
              <CustomHoverContext>
                <Routes>
                  <Route path="/" element={
                    <AuthRoute><LoginForm /></AuthRoute>
                  } />
                  <Route path="/login" element={
                    <AuthRoute><LoginForm /></AuthRoute>
                  } />
                  <Route path="/signup" element={
                    <AuthRoute><RegisterForm /></AuthRoute>
                  } />
                  <Route path="/forgotpassword" element={
                    <AuthRoute><ForgotForm /></AuthRoute>
                  } />
                  <Route path="/reset-password" element={
                    <AuthRoute><ResetForm /></AuthRoute>
                  } />
                  <Route path="/reset-password/:token" element={
                    <AuthRoute><ResetForm /></AuthRoute>
                  } />
                  <Route path="/otp" element={
                    <AuthRoute><OtpForm /></AuthRoute>
                  } />

                  {/* Private routes (protected) */}
                  <Route
                    path="/base"
                    element={
                      <PrivateRoute>
                        <BaseList userDetails1={UserDetailsData} />
                      </PrivateRoute>
                    }
                  />

                  {/* <Route
                    path="/:baseId/"
                    element={
                      <PrivateRoute>
                        <JobHomeLayout userDetails1={UserDetailsData}>
                          <Route path="dashboard" element={<BaseJobList userDetails1={UserDetailsData} />} />
                        </JobHomeLayout>
                      </PrivateRoute>
                    }
                  /> */}
                  <Route
                    path="/:baseId/dashboard/"
                    element={
                      <PrivateRoute>
                        <JobHomeLayout userDetails1={UserDetailsData} />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/:baseId/jobs/"
                    element={
                      <PrivateRoute>
                        <JobHomeLayout userDetails1={UserDetailsData} />
                      </PrivateRoute>
                    }
                  />
                  <Route path="/:baseId/settings/*" element={
                    <PrivateRoute>
                      <SettingLayout userDetails={UserDetailsData}>
                        <Routes>
                          <Route path="/base/*" element={
                            <AdminRoute>
                              <DetailsLayout userDetails={UserDetailsData}>
                                <Routes>
                                  <Route index element={<BaseDetails userDetails={UserDetailsData} />} />
                                  <Route path="manage" element={<BaseManage />} />
                                  <Route path="board" element={<UserPage />} />
                                  <Route path="tags" element={<UserPage />} />
                                </Routes>
                              </DetailsLayout>
                            </AdminRoute>
                          } />



                          {/* biiing */}

                          <Route path="billing/*" element={
                            <AdminRoute>
                              <BillingLayout userDetails={UserDetailsData}>
                                <Routes>
                                  <Route index element={<Navigate to="manage" replace />} />
                                  <Route path="manage" element={<BillingPlan userDetails={UserDetailsData} />} />
                                  <Route path="invoice" element={<BillingInvoice userDetails={UserDetailsData} />} />
                                </Routes>
                              </BillingLayout>
                            </AdminRoute>
                          } />





                          <Route path="/member/*" element={
                            <AdminRoute>
                              <MemberLayout userDetails={UserDetailsData}>
                                <Routes>
                                  <Route index element={<BaseMember userDetails={UserDetailsData} />} />
                                  <Route path="pending" element={<BaseMemberPending userDetails={UserDetailsData} />} />
                                </Routes>
                              </MemberLayout>
                            </AdminRoute>
                          } />

                          <Route path="teams/*" element={
                            <AdminRoute>
                              <Teams userDetails={UserDetailsData} />
                            </AdminRoute>
                          } />

                          <Route path="teams/:userId/detail/*" element={
                            <AdminRoute>
                              <TeamMemberLayout userDetails={UserDetailsData}>
                                <Routes>
                                  <Route index element={<TeamMemberDetails userDetails={UserDetailsData} />} />
                                  <Route path="member" element={<TeamMemberDataDetails userDetails={UserDetailsData} />} />
                                  <Route path="pending" element={<TeamMemberPending userDetails={UserDetailsData} />} />
                                </Routes>
                              </TeamMemberLayout>
                            </AdminRoute>
                          } />

                          <Route path="tags" element={
                            <AdminRoute>
                              <Tags />
                            </AdminRoute>
                          }
                          />
                          <Route path="location" element={
                            <AdminRoute>
                              <BaseLocation userDetails={UserDetailsData} />
                            </AdminRoute>
                          }
                          />
                          <Route path="department/*" element={
                            <AdminRoute>
                              <Departments userDetails={UserDetailsData} />
                            </AdminRoute>
                          } />
                          <Route path="department/:userId/detail/*" element={
                            <AdminRoute>
                              <DepartmentMemberLayout userDetails={UserDetailsData}>
                                <Routes>
                                  <Route index element={<DepartmentMemberDetails userDetails={UserDetailsData} />} />
                                  <Route path="list" element={<TeamMemberDataDetails userDetails={UserDetailsData} />} />
                                </Routes>
                              </DepartmentMemberLayout>
                            </AdminRoute>
                          } />
                          <Route path="department/:departmentId/edit" element={
                            <AdminRoute>
                              <CreateDepartment userDetails={UserDetailsData} />
                            </AdminRoute>
                          } />
                          <Route path="department/:departmentId/view" element={
                            <AdminRoute>
                              <ViewDepartment userDetails={UserDetailsData} />
                            </AdminRoute>
                          } />
                          <Route path="pipeline" element={
                            <AdminRoute>
                              <Pipeline userDetails={UserDetailsData} />
                            </AdminRoute>
                          }
                          />
                          <Route path="pipeline/:userId" element={
                            <AdminRoute>
                              <PipelineStages userDetails={UserDetailsData} />
                            </AdminRoute>
                          } />
                          <Route path="scorecard" element={
                            <AdminRoute>
                              <ScoreCard userDetails={UserDetailsData} />
                            </AdminRoute>
                          }
                          />
                          <Route path="scorecard/:userId" element={
                            <AdminRoute>
                              <Skills userDetails={UserDetailsData} />
                            </AdminRoute>
                          } />
                          <Route path="questionnaire" element={
                            <AdminRoute>
                              <Questionnaire userDetails={UserDetailsData} />
                            </AdminRoute>
                          }
                          />
                          <Route path="questionnaire/:userId" element={
                            <AdminRoute>
                              <QuestionList userDetails={UserDetailsData} />
                            </AdminRoute>
                          } />
                          <Route path="email" element={
                            <AdminRoute>
                              <Email userDetails={UserDetailsData} />
                            </AdminRoute>
                          }
                          />
                          <Route path="email/create" element={
                            <AdminRoute>
                              <CreateEmail userDetails={UserDetailsData} />
                            </AdminRoute>
                          }
                          />
                          <Route path="email/edit/:userId" element={
                            <AdminRoute>
                              <CreateEmail userDetails={UserDetailsData} />
                            </AdminRoute>
                          }
                          />
                          <Route path="email/:userId" element={
                            <AdminRoute>
                              <QuestionList userDetails={UserDetailsData} />
                            </AdminRoute>
                          } />

                          <Route path="reviewtemplate" element={
                            <AdminRoute>
                              <Review userDetails={UserDetailsData} />
                            </AdminRoute>
                          }
                          />
                          <Route path="reviewtemplate/create" element={
                            <AdminRoute>
                              <CreateReview userDetails={UserDetailsData} />
                            </AdminRoute>
                          }
                          />
                          <Route path="reviewtemplate/edit/:userId" element={
                            <AdminRoute>
                              <CreateReview userDetails={UserDetailsData} />
                            </AdminRoute>
                          }
                          />
                          {/* <Route path="reviewtemplate/:userId" element={
                            <AdminRoute>
                              <QuestionList userDetails={UserDetailsData} />
                            </AdminRoute>
                          } /> */}

                        </Routes>
                      </SettingLayout>
                    </PrivateRoute>
                  } />

                  {/* Other routes remain unchanged */}
                  <Route
                    path="/createbase"
                    element={
                      <PrivateRoute>
                        <CreateBase userDetails={UserDetailsData} />
                      </PrivateRoute>
                    }
                  />
                  {/* create new job */}
                  <Route
                    path="/:baseId/newjob"
                    element={
                      <PrivateRoute>
                        <CreateNewJob userDetails={UserDetailsData} />
                      </PrivateRoute>
                    }
                  />

                  <Route
                    path="/:baseId/job/:jobId/*"
                    // path="/:baseId/*"
                    element={
                      <JobProvider baseId={baseId} >
                        <PrivateRoute>
                          <DashboardLayout userDetails={UserDetailsData}>
                            <Suspense fallback={<LoadingSpinner />}>
                              <Routes>
                                {/* this is job dashboard route */}
                                <Route path="dashboard" element={<DashboardHome />} />
                                <Route path="inbox" element={<Inbox />} />
                                <Route path="inbox/app/:applicationId" element={<Inbox />} />
                                <Route path="activity" element={<Updates />} />
                                <Route path="activity/app/:applicationId" element={<Updates />} />
                                <Route path="applications" element={<Application />} />
                                <Route path="applications/app/:applicationId" element={<Application />} />
                                <Route path="task/*" element={<TaskListing />} />
                                <Route path='calender' element={<Calender />} />
                                <Route path='report' element={<ApplicationJobHeaderReports />} />
                                <Route path='pipeline' element={<Kanban />} />
                                <Route path="candidates" element={<JobDetailsListing />} />
                                <Route path="bookmark" element={<Bookmark />} />
                                <Route path="rating" element={<Rating />} />
                                  <Route path="evaluation" element={<Evaluation />} />

                                {/* unused routes */}
                                {/* <Route path="document" element={<DashboardHome />} /> */}
                                {/* <Route path="jobs" element={<JobsListing />} /> */}
                              </Routes>
                            </Suspense>
                          </DashboardLayout>
                        </PrivateRoute>
                      </JobProvider>
                    }
                  />


                  {/* job setting listing*/}

                  <Route
                    path="/:baseId/job/:jobId/manage/*"
                    element={
                      <JobApplicationProvider>
                        <PrivateRoute>
                          <JobAdminRoute>
                            <JobLayout userDetails={UserDetailsData}>
                              <Suspense fallback={<LoadingSpinner />}>
                                <Routes>
                                  <Route path="detail/*" element={<JobHome />} />
                                  <Route path="pipeline/*" element={<PipelineContainer />} />
                                  <Route path="hiring_team/*" element={<HiringPipelineContainer />} />
                                  <Route path="scorecard/*" element={<ScoreCardContainer />} />
                                  <Route path="scorecard/:userId" element={<ScoreCardSkill userDetails={UserDetailsData} />} />
                                  <Route path="questionnaire/*" element={<JobQuestionnaireContainer />} />
                                  <Route path="questionnaire/:userId" element={<JobQuestionSetDetails />} />
                                  <Route path="reviewtemplate/*" element={<ReviewTemplateContainer />} />
                                  <Route path="reviewtemplate/:userId" element={<EditReviewTemplateDetails />} />
                                  <Route path="reviewtemplate/create*" element={<CreateReviewTemplateDetails />} />
                                  {/* <Route path="reviewtemplate" element={<CreateReviewTemplateDetails />} /> */}
                                  <Route path="distribution/*" element={<DistributionContainer  />} />
                                  <Route path="application/*" element={<JobApplication />} />
                                  <Route path="actions/*" element={<JobActionDetails />} />
                                  <Route path="internal/*" element={<JobInternal />} />
                                  <Route path="evaluation/*" element={<EvaluationApplication />} />
                                </Routes>
                              </Suspense>
                            </JobLayout>
                          </JobAdminRoute>

                        </PrivateRoute>
                      </JobApplicationProvider>
                    }
                  />


                  {/* jpb details listing */}

                  <Route
                    path="/:baseId/job/:jobId/*"
                    element={
                      <PrivateRoute>
                        <ApplicationLayout userDetails={UserDetailsData}>
                          <Suspense fallback={<LoadingSpinner />}>
                            <Routes>
                              <Route path="application" element={<JobDetailsListing />} />
                              <Route path="pipeline" element={<JobDetailsListing />} />
                              <Route path="reports" element={<ApplicationJobHeaderReports />} />
                            </Routes>
                          </Suspense>
                        </ApplicationLayout>
                      </PrivateRoute>
                    }
                  />


                  {/* job application details */}
                  {/* test */}
                  <Route
                    path="/:baseId/job/:jobId/app/:applicationId/*"
                    element={
                      <PrivateRoute>
                        <CandidateLayout userDetails={UserDetailsData}>
                          <Suspense fallback={<LoadingSpinner />}>
                            <Routes>
                              <Route path="overview/*" element={<JobHome />} />
                              <Route path="resume/*" element={<PipelineContainer />} />
                              <Route path="scorecards/:skillId*" element={<JobSkillScorecard />} />
                              <Route path="scorecards/:skillId/edit*" element={<JobSkillScorecard />} />
                               <Route path="ai_interview/*" element={<CandidateAiInterview />} />
                            </Routes>
                          </Suspense>
                        </CandidateLayout>
                      </PrivateRoute>
                    }
                  />



                  {/* <Route
              path="/:baseId/job/:jobId/*"
              element={
                <JobApplicationProvider>
                  <PrivateRoute>
                    <JobLayout userDetails={UserDetailsData}>
                      <Suspense fallback={<LoadingSpinner />}>
                        <Routes>
                          <Route path="detail/*" element={<JobHome />} />
                          <Route path="pipeline/*" element={<PipelineContainer />} />
                          <Route path="hiring_team/*" element={<HiringPipelineContainer />} />
                          <Route path="scorecard/*" element={<ScoreCardContainer />} />
                          <Route path="scorecard/:userId" element={<ScoreCardSkill userDetails={UserDetailsData} />} />
                          <Route path="questionnaire/*" element={<JobQuestionnaireContainer />} />
                          <Route path="questionnaire/:userId" element={<JobQuestionSetDetails />} />
                          <Route path="application/*" element={<JobApplication />} />
                        </Routes>
                      </Suspense>
                    </JobLayout>
                  </PrivateRoute>
                </JobApplicationProvider>
              }
            /> */}

                  <Route path="user/:userId/*" element={
                    <PrivateRoute>
                      <UserLayout userDetails={UserDetailsData}>
                        <Routes>
                          <Route path="profile" element={<UserProfile />} />
                          <Route path="security" element={<UserSecurity />} />
                        </Routes>
                      </UserLayout>
                    </PrivateRoute>
                  } />



                  <Route path="*" element={<NotFound />} />
                </Routes>
              </CustomHoverContext>

            </CustomVerticalMenuContext>

          </SidebarProvider>

        </EditorProvider>
      </SearchProvider>
    </Suspense>
  );
};

export default AppRoutes;